export const GET_ACTIVITY_LIST = "GET_ACTIVITY_LIST";
export const GET_ACTIVITY_LIST_SUCCESS = "GET_ACTIVITY_LIST_SUCCESS";
export const SET_ACTIVITY_LIST = "SET_ACTIVITY_LIST";
export const SET_ACTIVITY_FILTERS = "SET_ACTIVITY_FILTERS";
export const CLEAR_ACTIVITY_FILTERS = "CLEAR_ACTIVITY_FILTERS";
export const SET_OLDEST_ACTIVITY_DATE = "SET_OLDEST_ACTIVITY_DATE";
export const SET_ACTIVITY_OFFSET = "SET_ACTIVITY_OFFSET";
export const SET_ACTIVITY_LOADING = "SET_ACTIVITY_LOADING";
